import { useState } from 'react'
import { Link } from 'react-router-dom'
import { API_CONFIG } from '../constants/config'
import './ResellerApply.css'

function ResellerApply() {
  const [form, setForm] = useState({
    name: '',
    email: '',
    phone: '',
    businessName: '',
    city: '',
    motivation: '',
    cbu: '',
    alias: '',
    mpPayerEmail: ''
  })
  const [isLoading, setIsLoading] = useState(false)
  const [error, setError] = useState('')
  const [success, setSuccess] = useState(false)

  const handleChange = (e) => {
    const { name, value } = e.target
    setForm(prev => ({ ...prev, [name]: value }))
    setError('')
  }

  const handleSubmit = async (e) => {
    e.preventDefault()
    setError('')

    // Validación básica
    if (!form.name.trim() || !form.email.trim() || !form.phone.trim()) {
      setError('Nombre, email y teléfono son obligatorios')
      return
    }

    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/
    if (!emailRegex.test(form.email)) {
      setError('Ingresá un email válido')
      return
    }

    setIsLoading(true)

    try {
      const response = await fetch(`${API_CONFIG.ADMIN_API_URL}/reseller/apply`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          name: form.name.trim(),
          email: form.email.trim().toLowerCase(),
          phone: form.phone.trim(),
          businessName: form.businessName.trim() || undefined,
          city: form.city.trim() || undefined,
          motivation: form.motivation.trim() || undefined,
          cbu: form.cbu.trim() || undefined,
          alias: form.alias.trim() || undefined,
          mpPayerEmail: form.mpPayerEmail.trim() || undefined
        })
      })

      const data = await response.json()

      if (!response.ok) {
        throw new Error(data.message || 'Error al enviar la solicitud')
      }

      setSuccess(true)
    } catch (err) {
      setError(err.message || 'Error de conexión. Intentá de nuevo.')
    } finally {
      setIsLoading(false)
    }
  }

  if (success) {
    return (
      <div className="reseller-apply-container">
        <div className="reseller-apply-card">
          <div className="reseller-apply-header">
            <div className="logo-circle">
              <span className="logo-icon">✅</span>
            </div>
            <h1>¡Solicitud Enviada!</h1>
            <p>
              Recibimos tu solicitud para ser revendedor GrowPro.
              Nuestro equipo la revisará y te contactaremos a <strong>{form.email}</strong> con novedades.
            </p>
          </div>
          <Link to="/login" className="reseller-apply-link">
            ← Ir al login
          </Link>
        </div>
      </div>
    )
  }

  return (
    <div className="reseller-apply-container">
      <div className="reseller-apply-card">
        <div className="reseller-apply-header">
          <div className="logo-circle">
            <span className="logo-icon">🌱</span>
          </div>
          <h1>Ser Revendedor GrowPro</h1>
          <p>Completá el formulario para postularte como revendedor. Revisaremos tu solicitud y te contactaremos.</p>
        </div>

        <form onSubmit={handleSubmit} className="reseller-apply-form">
          {error && <div className="error-message">{error}</div>}

          <div className="form-group">
            <label htmlFor="name">Nombre completo *</label>
            <input
              id="name"
              name="name"
              type="text"
              value={form.name}
              onChange={handleChange}
              placeholder="Tu nombre y apellido"
              disabled={isLoading}
              autoComplete="name"
            />
          </div>

          <div className="form-group">
            <label htmlFor="email">Email *</label>
            <input
              id="email"
              name="email"
              type="email"
              value={form.email}
              onChange={handleChange}
              placeholder="tu@email.com"
              disabled={isLoading}
              autoComplete="email"
            />
          </div>

          <div className="form-group">
            <label htmlFor="phone">Teléfono / WhatsApp *</label>
            <input
              id="phone"
              name="phone"
              type="tel"
              value={form.phone}
              onChange={handleChange}
              placeholder="+54 11 1234-5678"
              disabled={isLoading}
              autoComplete="tel"
            />
          </div>

          <div className="form-row">
            <div className="form-group">
              <label htmlFor="businessName">Nombre del negocio</label>
              <input
                id="businessName"
                name="businessName"
                type="text"
                value={form.businessName}
                onChange={handleChange}
                placeholder="Tu growshop o emprendimiento"
                disabled={isLoading}
              />
            </div>

            <div className="form-group">
              <label htmlFor="city">Ciudad</label>
              <input
                id="city"
                name="city"
                type="text"
                value={form.city}
                onChange={handleChange}
                placeholder="Ej: Buenos Aires"
                disabled={isLoading}
              />
            </div>
          </div>

          <div className="form-group">
            <label htmlFor="motivation">¿Por qué querés ser revendedor?</label>
            <textarea
              id="motivation"
              name="motivation"
              value={form.motivation}
              onChange={handleChange}
              placeholder="Contanos sobre tu experiencia, tu público objetivo, y por qué te interesa GrowPro"
              disabled={isLoading}
              rows={4}
            />
          </div>

          <div className="form-section-divider">
            <span>Datos de pago (opcional)</span>
          </div>

          <div className="form-row">
            <div className="form-group">
              <label htmlFor="cbu">CBU</label>
              <input
                id="cbu"
                name="cbu"
                type="text"
                value={form.cbu}
                onChange={handleChange}
                placeholder="CBU para transferencias"
                disabled={isLoading}
              />
            </div>
            <div className="form-group">
              <label htmlFor="alias">Alias bancario</label>
              <input
                id="alias"
                name="alias"
                type="text"
                value={form.alias}
                onChange={handleChange}
                placeholder="Ej: mi.alias.banco"
                disabled={isLoading}
              />
            </div>
          </div>

          <div className="form-group">
            <label htmlFor="mpPayerEmail">Email de MercadoPago</label>
            <input
              id="mpPayerEmail"
              name="mpPayerEmail"
              type="email"
              value={form.mpPayerEmail}
              onChange={handleChange}
              placeholder="Email de tu cuenta de MercadoPago"
              disabled={isLoading}
            />
          </div>

          <button type="submit" className="reseller-apply-button" disabled={isLoading}>
            {isLoading ? 'Enviando...' : 'Enviar Solicitud'}
          </button>
        </form>

        <div className="reseller-apply-footer">
          <p>¿Ya tenés cuenta? <Link to="/login">Iniciar sesión</Link></p>
        </div>
      </div>
    </div>
  )
}

export default ResellerApply
